import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { isLoaded, useFirestoreConnect } from 'react-redux-firebase'

import { useAuth } from './use-auth'

import { OrganizationUserType } from 'app/types'

export const useOrganizationUsers = () => {
    const { orgId } = useAuth()

    useFirestoreConnect({
        collection: `usersPerOrg/${orgId}/users`,
        storeAs: 'orgUsers'
    })

    const orgUsers = useSelector(state => state.firestore.data.orgUsers)

    return useMemo(
        () => ({
            orgUsers: Object.fromEntries(
                Object.entries<OrganizationUserType>(orgUsers || {}).filter(([_, val]) => val)
            ),
            loadingOrgUsers: !isLoaded(orgUsers)
        }),
        [orgUsers]
    )
}
